import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useColumn } from '../columns/column-context';
import {
  HighlightContentBase,
  type HighlightElement,
  HighlightElementBase
} from './highlight-element-base';

export function Ribbon({ ...forwardingProps }: HighlightElement) {
  const { highlightLabel: text } = useColumn();

  if (!text) {
    return null;
  }

  return (
    <Container {...forwardingProps}>
      <Content>{text}</Content>
    </Container>
  );
}

const Container = styled(HighlightElementBase).attrs({
  className: createReadableClass({ component: 'ribbon', element: 'container' })
})`
  pointer-events: none;
  height: 120px;
  overflow: hidden;
`;

const Content = styled(HighlightContentBase).attrs({
  style: {
    position: 'absolute'
  },
  className: createReadableClass({ component: 'ribbon' })
})`
  top: 18px;
  right: -30px;
  width: 128px;
  height: 32px;
  padding: 9px 20px 8px;
  margin: 0;
  transform: rotate(45deg);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
`;
